<template>
  <div>
    <h2 class="mt-6 mb-6">
      {{ machine.serial_number }}
      <br />
      {{ machine.name }}
    </h2>
    <h3 class="mb-3">
      支付方式
      <small v-if="!$payment_method_ids.length" class="red--text ml-3">* 至少擇一</small>
    </h3>

    <v-form>
      <v-card-text>
        <template v-for="payment_method in tempData">
          <v-checkbox
            v-model="payment_method.available"
            :label="payment_method.display_name"
            color="teal"
          ></v-checkbox>
        </template>
      </v-card-text>

      <div class="text-center">
        <v-btn @click="reset" outlined color="blue-grey lighten-3" class="mr-3">重設</v-btn>
        <v-btn @click="dialog = true" :disabled="!$payment_method_ids.length" color="teal">變更</v-btn>
      </div>
    </v-form>

    <Confirm @confirm="confirm" :dialog="dialog" title="是否確認變更支付方式？" text />
  </div>
</template>



<script>
import { mapState, mapActions } from "vuex";

import machineApi from "@/api/machine";

import Confirm from "@/components/Confirm";

export default {
  components: {
    Confirm
  },

  mixins: [],

  props: ["id"],
  data() {
    return {
      machine: {},
      payment_methods: [],
      tempData: [],

      dialog: false
    };
  },

  computed: {
    $payment_method_ids() {
      const payment_method_ids = [];
      this.tempData.forEach(payment_method => {
        if (payment_method.available) {
          payment_method_ids.push(payment_method.payment_method_id);
        }
      });

      return payment_method_ids;
    }
  },
  watch: {},
  methods: {
    ...mapActions("system", ["set_snackbar"]),

    resHandling(res) {
      this.machine = res.machine;
      this.payment_methods = JSON.parse(JSON.stringify(res.payment_methods));
      this.tempData = JSON.parse(JSON.stringify(res.payment_methods));
    },

    confirm(result) {
      this.dialog = false;

      if (result) {
        this.submit();
      } else {
        this.reset();
      }
    },

    reset() {
      this.tempData = JSON.parse(JSON.stringify(this.payment_methods));
    },

    submit() {
      machineApi
        .updatePaymentMethods(this.id, {
          payment_method_ids: this.$payment_method_ids
        })
        .then(res => {
          if (res.status !== 0) {
            this.set_snackbar({
              color: "error",
              text: res.message
            });

            this.reset();
          } else {
            this.resHandling(res);
          }
        })
        .catch(err => {});
    }
  },

  mounted() {
    machineApi
      .getPaymentMethods(this.id)
      .then(res => {
        this.resHandling(res);
      })
      .catch(err => {});
  }
};
</script>

<style lang="scss" scoped>
</style>
